import { RootState } from '../../../applicationStore';
import { ScheduledValuesState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getScheduledValuesState = (
  state: RootState,
): ScheduledValuesState => state.scheduledValues;

export const getScheduledValuesLoader = createSelector(
  getScheduledValuesState,
  (state): boolean => state.loading,
);

export const getScheduledValuesData = createSelector(
  getScheduledValuesState,
  (state): ScheduledValuesState['data'] | null => state?.data || [],
);
